import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 注册i18n实例并引入语言文件，文件格式等下解析
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    'zh': require('./langs/zh.json'),
    'en': require('./langs/en.json')
  }
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js